import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import urls from '../../constants/urls.js';
import GigService from '../../services/gigService';
import trimEnd from 'lodash/trimEnd';

const ResultItem = ({item}) => { 
    const getGigArtists = () => {
        const artistLinks = [];
        const artistDetails = [];
        const artists = item.Artists;
        for (let username in artists) {
            if (artists.hasOwnProperty(username)) 
            {
                const displayName = artists[username];
                artistDetails.push([username, displayName]);                
            }
        }
        for(let i = 0; i < artistDetails.length; i++) {
            artistLinks.push(getGigArtist(artistDetails[i][0], artistDetails[i][1], i, artistDetails.length));
        }
        return artistLinks;
    };
    
    const getGigArtist = (username, displayName, index, count) => {
        let separator = index < count - 1 ? ', ':'';
        return (<span key={username}>
            <Link className="transition" to={`/${username}`}>{displayName}</Link>
            <span>{separator}</span>
        </span>);
    };

    let artistIndex = 0;
    let gigDate = new Date(item.StartDate);
    return (
        <div className="card-event mdl-card mdl-shadow--2dp">
        <div className="mdl-card__title">
            <div className="mld-card__cal">
                <h4>
                    {gigDate.toLocaleDateString('en-GB', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' })}
                    <br />
                    {gigDate.toLocaleTimeString('en-GB', { hour: 'numeric', hour12: true, minute: '2-digit' }).toUpperCase()}
                </h4>
            </div>
            <div className="mdl-card__song">
                <h2 className="mdl-card__title-text"><Link style={{color:"black"}} to={`/Gigs/${item.ID}`}>{item.EventName}</Link></h2>
                <p className="artist">
                {
                    getGigArtists()
                }                    
                </p>
                <p className="location">
                    {`${item.Venue} - ${item.Location}`}
                    <br/>
                    Price: {item.TicketPrice}
                </p>
                <p className="genres">
                    {item.Genres.map((genre) =>                      
                        <span key={genre} className="badge transition">{genre}</span>
                    )}
                </p>
                {
                    item.Distance ?
                        item.Distance < 1 ?
                        <p className="location">{`Distance: < 1 ${trimEnd(item.DistanceUnit, "s")}`}</p>
                        :
                        <p className="location">Distance: {`${parseFloat(item.Distance.toFixed(1)).toString()} ${item.DistanceUnit}`}</p>
                    : null
                }
            </div>
        </div>
        <div className="mdl-card__actions mdl-card--border">
            <Link to={`/Gigs/${item.ID}`} className="mdl-button mdl-button--colored mdl-button__orange mdl-js-button mdl-js-ripple-effect">
                Details
            </Link>
        </div>
    </div>




        
    );
};

ResultItem.propTypes = {
    item: PropTypes.object.isRequired
};

export default ResultItem;